import { AppThunk } from '../../../store'
import {
  getTrainerSchedulePending,
  getTrainerScheduleSuccess,
  getTrainerScheduleFailure,
} from '.'
import { TrainerSchedule, FetchTrainerScheduleType } from '../onDemandWorkouts'
import configuration from '../../../../configuration'
import { request } from '../../../../common/utility/fetch'

const fetchTrainerSchedule = async (
  args: FetchTrainerScheduleType,
): Promise<TrainerSchedule> => {
  const baseUrl = configuration.trainerServiceApi
  const endpoint = `/api/v1/trainers/${args.trainerId}/schedule`
  const method = 'GET'
  const response = await request({
    baseUrl,
    endpoint,
    method,
  })
  const data = await response.json()

  return response.ok
    ? (data as TrainerSchedule)
    : Promise.reject(new Error(data.error))
}

export const getTrainerSchedule =
  (trainerId: string): AppThunk =>
  async (dispatch) => {
    dispatch(getTrainerSchedulePending(true))
    try {
      const response = await fetchTrainerSchedule({ trainerId })
      dispatch(getTrainerScheduleSuccess(response))
    } catch (error: any) {
      dispatch(getTrainerScheduleFailure(error.toString()))
    }
  }
